var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "31.036mm",
    height: "34.237mm",
    viewBox: "0 0 31.036 34.237",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient5764",
    x1: 59.321,
    x2: 90.357,
    y1: 220.65,
    y2: 220.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF802A",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF552A",
    offset: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-59.321 -203.53)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m80.144 203.53h-10.61c-5.6621 0-10.213 4.5773-10.213 10.213v9.2075c0 5.6356 4.5773 10.213 10.213 10.213h3.3338c0.9525 0.34396 1.6933 1.0848 2.0373 2.0902l0.10583 0.29104c0.44979 1.3229 1.6933 2.2225 3.0692 2.2225 6.7204 0 12.171-5.4504 12.171-12.171v-1.2171c0.05292-0.47625 0.10583-0.9525 0.10583-1.4288v-9.2075c0-5.6356-4.5773-10.213-10.213-10.213zm-11.615 18.944c0 1.0054-0.82021 1.8256-1.8256 1.8256h-0.21167c-1.0054 0-1.8256-0.82021-1.8256-1.8256v-7.8581c0-1.0054 0.82021-1.8256 1.8256-1.8256h0.21167c1.0054 0 1.8256 0.82021 1.8256 1.8256zm5.6356 3.0692c0 1.0583-0.84667 1.9315-1.9315 1.9315-1.0583 0-1.9315-0.84667-1.9315-1.9315v-13.996c0-1.0583 0.84667-1.9315 1.9315-1.9315 1.0583 0 1.9315 0.84667 1.9315 1.9315zm5.6356-0.87312c0 1.0583-0.84667 1.9315-1.9315 1.9315-1.0848 0-1.9315-0.84667-1.9315-1.9315v-12.25c0-1.0583 0.84667-1.9315 1.9315-1.9315 1.0848 0 1.9315 0.84667 1.9315 1.9315zm5.1858-0.71438c0 0.92604-0.76729 1.6933-1.6933 1.6933s-1.6933-0.74084-1.6933-1.6933v-10.848c0-0.92604 0.76729-1.6933 1.6933-1.6933s1.6933 0.76729 1.6933 1.6933z",
    fill: "url(#linearGradient5764)",
    strokeWidth: 0.26458
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.8ba8a626c4791910aee2e34151170dc7.svg";
export { ForwardRef as ReactComponent };